import React from 'react';

import { ChocoSelect } from '../../../../../components/FormComponents';
import { TableHeader } from '../../../../../components/Table';

interface TableControlsProps {
  searchValue: string;
  pageSize: number;
  onSearchChange: (value: string) => void;
  onPageSizeChange: (size: number) => void;
}

// NOTE(#104): the login-method filter control that used to live here was
// removed. The GraphQL schema advertises `UserSearchFilter.loginMethod`
// (CRM-187), but the `userSearch` resolver in choco-backend ignores it (only
// `isPuppy` is threaded through to the search service), so the filter could
// only be applied client-side over the fetched page — which produced silent
// false negatives ("No users found" for SSO) and broke pagination. Reinstate
// the control once the backend resolver actually implements the filter.
export const TableControls: React.FC<TableControlsProps> = ({
  searchValue,
  pageSize,
  onSearchChange,
  onPageSizeChange,
}) => {
  const pageSizeOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ];

  return (
    <TableHeader
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search by name, phone, email, or ID..."
    >
      <div className="w-44">
        <ChocoSelect
          options={pageSizeOptions}
          value={pageSize.toString()}
          onSelectionChange={(selectedValue) => {
            if (selectedValue) {
              onPageSizeChange(parseInt(selectedValue, 10));
            }
          }}
          size="sm"
          aria-label="Select page size"
          showDescriptions={false}
        />
      </div>
    </TableHeader>
  );
};
